import {OLVIDO_PASS_TYPES} from '../../constants/olvidoPass.types'
import {OlvidoPassAction} from '../../interfaces/olvidoPass.interface'
import * as validacionesRegex from '../../utils/strings.utils'
import {Dispatch} from 'react'
import {State} from '../../reducers'
import {generalOpenModalError, generalShowLoader} from '../general.actions'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {KEYS} from '../../constants/keysStorage'

// ******************************************************************************************
export const olvidoPassFormRestablecerHandleChange = (form: any) => ({
  type: OLVIDO_PASS_TYPES.FORM_RESTABLECER_HANDLE_CHANGE,
  payload: form,
})

export const olvidoPassFormVerificarHandleChange = (form: any) => ({
  type: OLVIDO_PASS_TYPES.FORM_VERIFICAR_HANDLE_CHANGE,
  payload: form,
})

export const olvidoPassFormPasswordHandleChange = (form: any) => ({
  type: OLVIDO_PASS_TYPES.FORM_PASSWORD_HANDLE_CHANGE,
  payload: form,
})

export const olvidoPassClear = () => ({
  type: OLVIDO_PASS_TYPES.CLEAR,
  payload: null,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
// handle change formulario restablecer
export const olvidoPassFormRestablecerHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<OlvidoPassAction>) => {
    let {name, value} = e.target
    if (value) {
      switch (name) {
        case 'email':
          if (!validacionesRegex.validarRegexUsername(value)) return
          break
        case 'telefono':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break
        default:
          break
      }
    }
    dispatch(olvidoPassFormRestablecerHandleChange({[name]: value}))
  }

// handle change formulario codigo de verificacion
export const olvidoPassFormVerifyCodeHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<OlvidoPassAction>) => {
    let {name, value} = e.target
    if (value) {
      switch (name) {
        case 'code':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break
        default:
          break
      }
    }
    dispatch(olvidoPassFormVerificarHandleChange({[name]: value}))
  }

// handle change formulario nueva contraseña
export const olvidoPassFormNewPassHanldeCHangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<OlvidoPassAction>) => {
    let {name, value} = e.target
    if (value) {
      switch (name) {
        case 'passwd':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break
        case 'passwd2':
          if (!validacionesRegex.validarRegexLetras(value)) return
          break
        default:
          break
      }
    }
    dispatch(olvidoPassFormPasswordHandleChange({[name]: value}))
  }

// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
/**
 * olvdioPassFormRestablecerSend = envía al correo el código de verificación
 */
export const olvdioPassFormRestablecerSend =
  (email: string = '') =>
  async (dispatch: Dispatch<OlvidoPassAction>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const form = getState().olvidoPass.formRestablecer
    const body = {username: email || form.email.trim()}
    const message = 'No se logró enviar, inténtelo nuevamente'

    return await http
      .post(ENDPOINTS.OLVIDO_PASS_ENVIAR_EMAIL, body)
      .then((res: any) => {
        if (res.status === 200) {
          localStorage.setItem(OLVIDO_PASS_TYPES.KEY_EMAIL, body.username)
          return true
        }
        dispatch(generalOpenModalError(res?.message || message))
        return false
      })
      .catch((err) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

/**
 * olvdioPassVerificacionCodigoEnviar = verifica el código del usuario
 */
export const olvidoPassVerificacionCodigoEnviar =
  () => async (dispatch: Dispatch<OlvidoPassAction>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const form = getState().olvidoPass.formVerificar
    const body = {
      username: localStorage.getItem(OLVIDO_PASS_TYPES.KEY_EMAIL),
      code: form.code.trim(),
    }
    const message = 'No se logró verificar el código, inténtelo nuevamente'

    return await http
      .post(ENDPOINTS.OLVIDO_PASS_VERIFICAR_CODIGO, body)
      .then((res: any) => {
        if (res?.status === 200 && res?.data === true) {
          localStorage.removeItem(OLVIDO_PASS_TYPES.KEY_EMAIL)
          return true
        }
        dispatch(generalOpenModalError(res?.message || message))
        return false
      })
      .catch((err) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }
/**
 * olvdioPassEstablecerNuevaPass =
 * @param code codigo de verificación
 * @returns {Boolean} true = correcto, false = error
 */
export const olvidoPassEstablecerNuevaPass =
  (code: string) => async (dispatch: Dispatch<OlvidoPassAction>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const form = getState().olvidoPass.formPassword
    const body = {code: code.trim(), password: form.passwd}
    const message = 'Existió un inconveniente al cambiar la contraseña, inténtelo nuevamente'

    return await http
      .put(ENDPOINTS.OLVIDO_PASS_PUT_NUEVA_PASS, body)
      .then((res: any) => {
        if (res?.status === 200 && res?.data === true) {
          localStorage.removeItem(OLVIDO_PASS_TYPES.KEY_EMAIL)
          return true
        }
        dispatch(generalOpenModalError(res?.message || message))
        return false
      })
      .catch((err) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

/**
 * restablecerPasswordTemporal =
 * @returns {Boolean} true = correcto, false = error
 */
export const restablecerPasswordTemporal =
  () => async (dispatch: Dispatch<OlvidoPassAction>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const form = getState().olvidoPass.formPassword
    const username = localStorage.getItem(KEYS.USERNAME_CLIENTE_RESTORE)
    const body = {username, password: form.passwd}
    const message = 'Existió un inconveniente al cambiar la contraseña, inténtelo nuevamente'

    return await http
      .put(ENDPOINTS.RESTABLECER_PASS_TEMPORAL, body)
      .then((res: any) => {
        if (res?.status === 200 && res?.data === true) {
          localStorage.removeItem(KEYS.USERNAME_CLIENTE)
          localStorage.removeItem(KEYS.USERNAME_CLIENTE_RESTORE)
          localStorage.removeItem(KEYS.TOKEN)
          return true
        }
        dispatch(generalOpenModalError(res?.message || message))
        return false
      })
      .catch((err) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
        return false
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }
